// components/dashboard/EnquiryStats.jsx
import React from "react";
import { Grid, Box, Typography } from "@mui/material";
import { brand } from "../../../theme";
import InboxIcon from "@mui/icons-material/Inbox";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import TodayIcon from "@mui/icons-material/Today";
import { T } from "../../../theme";

const sq = { borderRadius: "4px !important" };

const StatCard = ({ label, value, icon, color, bgLight, bgDark, borderColor }) => (
  <Box
    sx={{
      position: "relative",
      overflow: "hidden",
      ...sq,
      border: `1.5px solid ${borderColor}`,
      bgcolor: "#fff",
      p: 1.25,
      display: "flex",
      alignItems: "center",
      gap: 1.1,
      minHeight: 74,
      transition: "all 0.2s ease",
      cursor: "default",
      boxShadow: `0 1px 6px ${borderColor}35`,
      "&:hover": {
        transform: "translateY(-2px)",
        boxShadow: `0 6px 16px ${borderColor}55`,
        borderColor: color,
      },
      "&::before": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        height: 2.5,
        background: `linear-gradient(90deg, ${color}, ${borderColor})`,
      },
    }}
  >
    {/* Icon */}
    <Box
      sx={{
        width: 36,
        height: 36,
        ...sq,
        bgcolor: bgLight,
        border: `1.5px solid ${borderColor}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        boxShadow: `0 2px 8px ${borderColor}30`,
        zIndex: 1,
      }}
    >
      {React.cloneElement(icon, { sx: { fontSize: 18, color } })}
    </Box>

    {/* Content */}
    <Box sx={{ flex: 1, minWidth: 0, zIndex: 1 }}>
      <Typography
        sx={{
          fontSize: "0.62rem",
          fontWeight: 700,
          color: T.textSub,
          textTransform: "uppercase",
          letterSpacing: "0.05em",
          lineHeight: 1,
          mb: 0.35,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {label}
      </Typography>

      <Typography
        sx={{
          fontSize: "1.3rem",
          fontWeight: 800,
          color,
          lineHeight: 1.05,
        }}
      >
        {value}
      </Typography>
    </Box>
  </Box>
);

const EnquiryStats = ({ stats }) => {
  const cards = [
    {
      label: "Total Enquiries",
      value: stats.total,
      icon: <InboxIcon />,
      color: brand.main,
      bgLight: "#f5f3ff",
      bgDark: "#ede9fe",
      borderColor: "#e0e7ff",
    },
    {
      label: "Unread",
      value: stats.unread,
      icon: <NotificationsActiveIcon />,
      color: "#d97706",
      bgLight: "#fffbeb",
      bgDark: "#fef3c7",
      borderColor: "#fde68a",
    },
    {
      label: "Read",
      value: stats.read,
      icon: <MarkEmailReadIcon />,
      color: "#059669",
      bgLight: "#ecfdf5",
      bgDark: "#d1fae5",
      borderColor: "#a7f3d0",
    },
    {
      label: "Today",
      value: stats.today,
      icon: <TodayIcon />,
      color: "#7c3aed",
      bgLight: "#f5f3ff",
      bgDark: "#ede9fe",
      borderColor: "#ddd6fe",
    },
  ];

  return (
    <Grid container spacing={1.5} sx={{ mb: 2 }}>
      {cards.map((card) => (
        <Grid item xs={6} sm={6} lg={3} key={card.label}>
          <StatCard {...card} />
        </Grid>
      ))}
    </Grid>
  );
};

export default EnquiryStats;